import { useNavigate } from "react-router-dom";
import LayoutPage from "../../Components/LayoutPage";
import NavLayer2 from "../../Components/NavLayer2/NavLayer2";
import HistoryTable from "./Components/HistoryTable";
import { API_BASE_URL } from "../../config/api";
import useInfinitePaginated from "../../hooks/useInfinitePaginated";

export default function History() {
  const navigate = useNavigate();
  const { data, initialLoading, loadingMore, error, hasNext, sentinelRef, scrollRootRef, retry } = useInfinitePaginated({ endpoint: `${API_BASE_URL}payment-payout/transactions/history/`, navigate });
  return (
    <LayoutPage activeIndex={6} navItems={["تراکنش‌ها"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5">
      <NavLayer2 texts={["برداشت", "تاریخچه تراکنش‌ها"]} hrefs={["/Transaction/Withdraw", "/Transaction/History"]} activeIndex={1} />
      <div className="w-full h-fit flex flex-col gap-5 min-h-0 overflow-y-auto">
        <HistoryTable historyData={data} accLoading={initialLoading} loadingMore={loadingMore} error={error} sentinelRef={sentinelRef} scrollRootRef={scrollRootRef} onRetry={retry} hasNext={hasNext} />
      </div>
    </LayoutPage>
  );
}
